/**
 * 节流函数，在规定时间内传入的函数只能执行一次。
 * @param {Function} fn 实际执行的函数
 * @param {Number} time 该时间段内 fn 至多触发一次，默认时间我300毫秒
 * @returns {Function} 返回一个function，实际调用的是这个function。
 */
export default function throttle(fn, time = 300) {
    let timer = null;

    // 这里不用箭头函数的原因是为了能够使用调用这个函数的对象的this上下文
    return function throttleHandler(...args) {
        if (timer === null) {
            // 这里不用 fn(...args)的原因还是为了保证this，因为 fn(...args) 会被编译成 fn.apply(undefined, args);
            fn.apply(this, args);
            timer = setTimeout(() => {
                timer = null;
            }, time);
        }
    };
}
